(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class HeaderShopSheet {
    constructor() {
      this.sheet = document.getElementById('HeaderShopSheet');
      this.trigger = document.querySelector('[data-shop-sheet-trigger]');
      this.wrapper = document.querySelector('.header-wrapper');
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.closeDelay = 120;
      this.closeTimer = null;

      if (!this.sheet || !this.trigger) return;

      this.open = this.open.bind(this);
      this.scheduleClose = this.scheduleClose.bind(this);
      this.cancelClose = this.cancelClose.bind(this);
      this.showOption = this.showOption.bind(this);

      this.optionLinks = this.sheet.querySelectorAll('[data-shop-sheet-option]');
      this.optionImages = this.sheet.querySelectorAll('[data-shop-sheet-image]');
      this.optionLinks.forEach((link) => {
        const activate = () => this.showOption(link.dataset.shopSheetOption);
        link.addEventListener('mouseenter', activate);
        link.addEventListener('focus', activate);
      });

      this.trigger.addEventListener('mouseenter', () => {
        this.cancelClose();
        this.open();
      });
      this.trigger.addEventListener('mouseleave', this.scheduleClose);
      this.sheet.addEventListener('mouseenter', () => {
        this.cancelClose();
        this.open();
      });
      this.sheet.addEventListener('mouseleave', this.scheduleClose);

      const summary = this.trigger.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => event.preventDefault());
      }

      this.desktopQuery.addEventListener('change', () => {
        if (!this.desktopQuery.matches) this.close();
      });
    }

    open() {
      if (!this.desktopQuery.matches) return;
      this.sheet.classList.add('is-open');
      this.sheet.setAttribute('aria-hidden', 'false');
      if (this.wrapper) this.wrapper.preventHide = true;
    }

    close() {
      this.sheet.classList.remove('is-open');
      this.sheet.setAttribute('aria-hidden', 'true');
      if (this.wrapper) this.wrapper.preventHide = false;
      this.resetOption();
    }

    showOption(id) {
      const image = this.sheet.querySelector(`[data-shop-sheet-image="${id}"]`);
      if (image) {
        this.optionImages.forEach((el) => el.classList.toggle('is-active', el === image));
      }
      this.optionLinks.forEach((link) => {
        link.classList.toggle('is-active', link.dataset.shopSheetOption === id);
      });
    }

    resetOption() {
      const first = this.optionImages[0];
      if (first) this.showOption(first.dataset.shopSheetImage);
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.close(), this.closeDelay);
    }

    cancelClose() {
      clearTimeout(this.closeTimer);
    }
  }

  class HeaderDrawerShop {
    constructor() {
      this.root = document.querySelector('.menu-drawer-celeste');
      if (!this.root) return;

      this.optionLinks = this.root.querySelectorAll('[data-drawer-shop-option]');
      this.optionImages = this.root.querySelectorAll('[data-drawer-shop-image]');
      this.collections = this.root.querySelector('.menu-drawer-celeste__collections');
      this.cta = this.root.querySelector('[data-drawer-shop-cta]');
      this.details = document.querySelector('#Details-menu-drawer-container');

      this.optionLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.showOption(link.dataset.drawerShopOption);
        });
      });

      if (this.details) {
        this.details.addEventListener('toggle', () => {
          if (!this.details.open) this.resetOption();
        });
      }
    }

    showOption(id) {
      this.optionImages.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.drawerShopImage === id);
      });
      this.optionLinks.forEach((link) => {
        const active = link.dataset.drawerShopOption === id;
        link.classList.toggle('is-active', active);
        if (!active) return;

        if (this.cta) {
          const href = link.getAttribute('href');
          if (href) {
            this.cta.setAttribute('href', href);
            this.cta.removeAttribute('role');
            this.cta.removeAttribute('aria-disabled');
          } else {
            this.cta.removeAttribute('href');
            this.cta.setAttribute('role', 'link');
            this.cta.setAttribute('aria-disabled', 'true');
          }
        }

        this.scrollSelectedIntoView(link);
      });
    }

    scrollSelectedIntoView(link) {
      if (!this.collections || !link) return;

      const first = this.optionLinks[0];
      const last = this.optionLinks[this.optionLinks.length - 1];
      const maxScroll = Math.max(0, this.collections.scrollWidth - this.collections.clientWidth);
      let left = 0;

      if (link === last) {
        left = maxScroll;
      } else if (link !== first) {
        const scrollerBox = this.collections.getBoundingClientRect();
        const linkBox = link.getBoundingClientRect();
        left = this.collections.scrollLeft + linkBox.left - scrollerBox.left - (scrollerBox.width - linkBox.width) / 2;
        left = Math.min(maxScroll, Math.max(0, left));
      }

      this.scrollCollectionsTo(left);
    }

    scrollCollectionsTo(left) {
      const el = this.collections;
      if (!el) return;

      if (this.collectionsScrollFrame) cancelAnimationFrame(this.collectionsScrollFrame);

      const start = el.scrollLeft;
      const change = left - start;
      if (Math.abs(change) < 1) {
        el.scrollLeft = left;
        return;
      }

      const duration = 280;
      const startTime = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - startTime) / duration);
        const eased = 1 - (1 - t) ** 3;
        el.scrollLeft = start + change * eased;
        if (t < 1) {
          this.collectionsScrollFrame = requestAnimationFrame(step);
        } else {
          el.scrollLeft = left;
          this.collectionsScrollFrame = null;
        }
      };

      this.collectionsScrollFrame = requestAnimationFrame(step);
    }

    resetOption() {
      const first = this.optionLinks[0];
      if (first) this.showOption(first.dataset.drawerShopOption);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new HeaderShopSheet();
      new HeaderDrawerShop();
    });
  } else {
    new HeaderShopSheet();
    new HeaderDrawerShop();
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-header-search]');
    if (!opener) return;

    event.preventDefault();

    const menuDetails = document.querySelector('#Details-menu-drawer-container');
    if (menuDetails && menuDetails.hasAttribute('open')) {
      const menuSummary = menuDetails.querySelector('summary');
      if (menuSummary) menuSummary.click();
    }

    const searchSummary = document.querySelector('details-modal.header__search details > summary');
    if (searchSummary) searchSummary.click();
  });

  } catch(e) { console.error(e); }
})();
})();
